export const SET_CHECKOUT_AGREEMENTS = 'SET_CHECKOUT_AGREEMENTS';
